module.exports = __webpack_public_path__ + "static/proj2hero-61a929eda6ea64878d7cf513e4f4b86b.png";